import InfoTestField from './InfoTestField';
import { InfoTestFieldProps, InfoTestFieldValueProps } from './types';

export type { InfoTestFieldProps, InfoTestFieldValueProps };
export default InfoTestField;
